import { ChefHat } from 'lucide-react';
interface AuthLoadingStateProps {
  message?: string;
}
export const AuthLoadingState = ({
  message = 'Preparing your kitchen...'
}: AuthLoadingStateProps) => {
  return <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-midnight-green via-deep-teal to-midnight-green">
      {/* Ambient background effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-copper/10 rounded-full blur-3xl animate-float" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-ivory/10 rounded-full blur-3xl animate-float-slow" />
      </div>
      
      <div className="relative flex flex-col items-center gap-8 max-w-md px-6">
        {/* Chef hat animation */}
        <div className="relative">
          <ChefHat className="h-20 w-20 text-copper animate-bounce" />
          <div className="absolute inset-0 h-20 w-20 animate-ping opacity-20 rounded-full bg-copper" />
          
        </div>
        
        <div className="text-center space-y-3">
          <h2 className="text-2xl font-playfair font-bold text-ivory drop-shadow-lg">
            {message}
          </h2>
          <p className="text-ivory/70 text-lg">
            This should only take a moment
          </p>
        </div>

        {/* Animated dots */}
        <div className="flex gap-2 mt-4">
          <div className="h-3 w-3 rounded-full bg-copper animate-bounce [animation-delay:-0.3s] shadow-lg shadow-copper/50" />
          <div className="h-3 w-3 rounded-full bg-copper animate-bounce [animation-delay:-0.15s] shadow-lg shadow-copper/50" />
          <div className="h-3 w-3 rounded-full bg-copper animate-bounce shadow-lg shadow-copper/50" />
        </div>
      </div>
    </div>;
};